<template>
<div id="contents">

  <div id="company" class="page_contents">

    <div id="company_contents">
      <div id="company_vivia">
        <div class="page_header">
          <h1 class="page_header_title">
            <img src="../assets/img/company/title.png" width="359" alt="WORKS" />
            <span>会社について</span>
          </h1><!-- .top_sec_title -->
        </div><!-- .page_header -->

        <companyPageNav />

        <div id="company_vivia_main" class="page_main_contents">
          <h3><img src="../assets/img/company/vivia/logo.png" width="416" alt="VIVIA" /></h3>

          <p class="read">テレビ朝日映像は、1998年から「VIVIA」というサブブランドを使用しています。</p><!-- .read -->

          <p class="abbreviation"><img src="../assets/img/company/vivia/abbreviation.png" width="518" alt="Visual Vivid Asahi Action" /></p><!-- .abbreviation -->

          <div id="company_vivia_main_inner">
            <p>イキイキとした映像、イキイキとした活動を、<br />幅広く展開していきたいという思いが込められています。<br />テレビ業界では「VIVIA」＝「テレビ朝日映像」と認知していただいており、<br />親しみやすいサブブランド名として使用しています。</p>
          </div><!-- #company_vivia_main_inner -->

        </div><!-- #company_vivia_main -->


      </div><!-- #company_vivia -->
    </div><!-- #company_contents -->
  </div><!-- #company -->



</div><!-- #contents -->
</template>

<script>
import companyPageNav from './shared/companyPageNav.vue'
export default {
  name: 'history_index',
  components: {
    companyPageNav
  },
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/vivia_index.vue